var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:("root-icon marathon-help-icon-" + _vm.icon),on:{"mouseleave":_vm.mouseleave,"mouseenter":_vm.mouseenter}})}
var staticRenderFns = []

export { render, staticRenderFns }